'use strict';

angular.module('cgmemApp')
	.controller('AdminCtrl', function ($scope, $rootScope, $http, $q, $log, WorkingAccount) {
		$scope.resetTestAccounts = function () {
			return $http.delete('/api/transactions/test')
				.then(function (res) {
					WorkingAccount.get(null, true);
					$rootScope.$emit('generalAlert', 'Done');
					return;
				}, function (res) {
					$rootScope.$emit('generalAlert', 'Error reseting test accounts: ' + (res.data || res.statusText));
				});
		}

	})

